// 判断元素类型
function _getTypeStr (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤
function _filterNull (o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (_getTypeStr(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (_getTypeStr(o[key]) === 'object') {
      o[key] = _filterNull(o[key])
    } else if (_getTypeStr(o[key]) === 'array') {
      o[key] = _filterNull(o[key])
    }
  }
  return o
}

function _objectDeepCopy (source) {
  var sourceCopy = source instanceof Array ? [] : {}
  for (var item in source) {
    sourceCopy[item] = typeof source[item] === 'object' ? _objectDeepCopy(source[item]) : source[item]
  }
  return sourceCopy
}

export default {
  getTypeStr (obj) {
    return _getTypeStr(obj)
  },
  filterNull (obj) {
    return _filterNull(obj)
  },
  objectDeepCopy (obj) {
    return _objectDeepCopy(obj)
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js